import { useState } from "react";
import "./App.css";
import Upload from "./Upload";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Login";
import Register from "./Register";
import BottleColl from "./BottleColl";
import { auth } from "./firebase-config";
import { onAuthStateChanged } from "firebase/auth";
import { useEffect } from "react";
import Header from "./Header";
import EnvHome from "./EnvHome";
import { getDocs, collection } from "@firebase/firestore";
import { db } from "./firebase-config";
import BottleCollInp from "./BottleCollInp";
import Chatbot from "./Chatbot";
import Events from "./Events";
import Awarness from "./Awarness";
import EcoProducts from "./EcoProducts";
import Rewards from "./Rewards";
import Home from "./Home";

function App() {
  const [currentUser, setCurrentUser] = useState();
  const [points, setPoints] = useState();
  const [lpoints, setLpoints] = useState();
  const [events, setEvents] = useState([]);
  const [ref, setRef] = useState();
  const [doc, setDoc] = useState();
  let event = [];
  const getEvents = async () => {
    await getDocs(collection(db, "Events")).then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        // setEvents((events) => [...events, doc.data()]);
        event.push(doc.data());
      });
    });
  };
  getEvents();
  console.log(currentUser);
  useEffect(() => {
    onAuthStateChanged(auth, (data) => {
      setCurrentUser(data.uid);
      const dbGet = async () => {
        console.log(currentUser);
        await getDocs(collection(db, "Users")).then((querySnapshot) => {
          console.log(querySnapshot);
          querySnapshot.forEach((doc) => {
            if (doc.data().uid === data.uid) {
              setRef(doc.id);
              setDoc(doc.data());
              setPoints(doc.data().cpoints);
              setLpoints(doc.data().lpoints);
            }
          });
        });
      };
      dbGet();
    });
  }, []);
  return (
    <Router>
      <div className="App">
        {(window.location.href === "http://localhost:3000/login") |
        (window.location.href === "http://localhost:3000/signin") ? (
          <noscript />
        ) : (
          <Header points={points} />
        )}
        <Chatbot />
        <Routes>
          <Route path="/upload" element={<Upload Uuid={currentUser} />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signin" element={<Register />} />
          <Route
            path="/bottlecoll"
            element={<BottleColl Buid={currentUser} Doc={doc} />}
          />
          <Route path="/envhome" element={<EnvHome />} />
          <Route
            path="/bottleinp"
            element={
              <BottleCollInp
                Buid={currentUser}
                Ref={ref}
                Points={points}
                lpoints={lpoints}
              />
            }
          />
          <Route path="/events" element={<Events Doc={doc} Events={event} />} />
          <Route path="/awarness" element={<Awarness />} />
          <Route path="/ecoproducts" element={<EcoProducts />} />
          <Route path="/rewards" element={<Rewards Points={lpoints} />} />
          <Route path="/" exact element={<Home />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
